import {
  OTP_RECOVERY_REQUEST_BUTTON_LABEL,
  OTP_RECOVERY_REQUEST_SUBTITLE,
  OTP_RECOVERY_REQUEST_TITLE,
  OTP_VERIFICATION_BACK_LABEL,
} from 'common/constants/auth';
import { Alert, Button, Stack } from 'components/ui';
import AuthFormHeader from 'pages/Auth/components/AuthFormHeader';
import AuthPageStack from 'pages/Auth/components/AuthPageStack';
import AuthTitleText from 'pages/Auth/components/AuthTitleText';
import { ActionButtons, otpActionButtonSx, RootPaper, Subtitle, Title } from 'pages/Auth/components/OTP/OTP.styles';
import { OTP_TEST_IDS } from 'pages/Auth/components/OTP/OTP.testIds';
import type { OtpRecoveryRequestProps } from './OtpRecoveryRequest.props';

const OtpRecoveryRequest = ({
  errorMessage,
  isSubmitting = false,
  showHeader = false,
  onBack,
  onRequestCode,
}: OtpRecoveryRequestProps) => {
  const [titleLead, ...titleTailParts] = OTP_RECOVERY_REQUEST_TITLE.split(' ');
  const titleTail = titleTailParts.join(' ');

  return (
    <AuthPageStack>
      {showHeader ? (
        <AuthFormHeader
          subtitle={OTP_RECOVERY_REQUEST_SUBTITLE}
          title={<AuthTitleText lead={titleLead} tail={titleTail} />}
        />
      ) : null}
      <RootPaper>
        <Stack spacing={4}>
          {!showHeader ? (
            <Stack spacing={2}>
              <Title>
                <AuthTitleText lead={titleLead} tail={titleTail} />
              </Title>
              <Subtitle>{OTP_RECOVERY_REQUEST_SUBTITLE}</Subtitle>
            </Stack>
          ) : null}
          {errorMessage ? (
            <Alert severity="error" visualVariant="inlineError">
              {errorMessage}
            </Alert>
          ) : null}
        </Stack>
        <ActionButtons>
          <Button
            data-testid={OTP_TEST_IDS.recoveryRequestBackButton}
            disabled={isSubmitting}
            id="auth-otp-recovery-request-back-button"
            onClick={onBack}
            variant="text"
            visualVariant="primaryGhost"
          >
            {OTP_VERIFICATION_BACK_LABEL}
          </Button>
          <Button
            data-testid={OTP_TEST_IDS.recoveryRequestSendButton}
            disabled={isSubmitting}
            id="auth-otp-recovery-request-send-button"
            loading={isSubmitting}
            onClick={onRequestCode}
            sizeVariant="compact"
            sx={otpActionButtonSx}
            variant="contained"
            visualVariant="positive"
          >
            {OTP_RECOVERY_REQUEST_BUTTON_LABEL}
          </Button>
        </ActionButtons>
      </RootPaper>
    </AuthPageStack>
  );
};

export default OtpRecoveryRequest;
